var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M17.64 9.2c0-.63-.06-1.25-.16-1.84H9v3.49h4.84c-.21 1.12-.87 2.07-1.86 2.71v2.26h2.94c1.74-1.57 2.72-3.87 2.72-6.62"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M9 18c2.43 0 4.47-.8 5.92-2.18l-2.94-2.26c-.81.54-1.82.86-2.98.86-2.34 0-4.33-1.58-5.04-3.71h-3v2.33A8.99 8.99 0 0 0 9 18"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M3.96 10.71c-.18-.54-.28-1.12-.28-1.71s.1-1.17.28-1.71V4.96h-3a8.98 8.98 0 0 0 0 8.08z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M9 3.58c1.32 0 2.51.45 3.44 1.34l2.55-2.55A8.6 8.6 0 0 0 9 0C5.48 0 2.44 2.02.96 4.96l3 2.33C4.67 5.16 6.66 3.58 9 3.58"
})));
export default SvgGoogleIcon;